import React from 'react';
import { Stack, Loader, Text, theme } from '@veeqo/ui';
import { ContentType, copy } from 'components/Landing/content';

export const Progress = ({
  loadingColor = 'white',
  contentType,
}: {
  loadingColor: string;
  contentType: ContentType;
}) => (
  <Stack
    direction="vertical"
    style={{
      flexWrap: 'wrap',
      alignItems: 'center',
      justifyContent: 'center',
      paddingTop: theme.sizes.md,
      minHeight: '5.5rem',
    }}
  >
    <Loader type="TailSpin" color={loadingColor} height={40} width={40} />
    <Text
      variant="subheadingMedium"
      style={{
        marginTop: theme.sizes.md,
      }}
    >
      {copy[contentType].progress}
    </Text>
  </Stack>
);
